import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/storage-near-me.jpg'),
    alt: 'storage near me page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'storage near me page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Affordable <span>Storage</span><span>Near Me Solutions</span>',
  description:
    "Looking for secure and affordable storage near you? Whether you're moving, decluttering, or need temporary storage, we have nearby options to keep your items safe and easily accessible.",
  image: {
    url: '/images/v2/pages/landing-pages/storage-near-me/hero-image.jpg',
    alt: 'Affordable Storage Near Me Solutions'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Find Storage Near You' }
}

export const ourProcessSectionContent = {
  title: 'How Storage Near Me Works',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/storage-near-me/how-storage-near-me-works.png',
    alt: 'How Storage Near Me Works'
  },

  articles: [
    {
      id: 1,
      title: 'Quick and Easy Search',
      description:
        'Find the closest storage units near you by entering your location online. Our system helps you compare options in your area to find the best fit.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-near-me/quick-and-easy-search.png',
        alt: 'Quick and Easy Search'
      }
    },
    {
      id: 2,
      title: 'Secure and Convenient',
      description:
        'All of our storage facilities are safe and secure, with 24/7 monitoring and easy access when you need it.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-near-me/secure-and-convenient.png',
        alt: 'Secure and Convenient'
      }
    },
    {
      id: 3,
      title: 'Flexible Storage Options',
      description:
        'Choose from a variety of storage unit sizes to suit your needs, whether you have a few boxes or a whole household to store.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-near-me/flexible-storage-options.png',
        alt: 'Flexible Storage Options'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Safe and Secure Storage Near Me',
  description:
    'At ShipAndStorage, we make it easy to find nearby storage options that are both secure and affordable. Our storage units are strategically located for your convenience, giving you quick access to your belongings without extra hassle.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-near-me/safe-and-secure-storage-near-me.jpg',
    alt: 'Safe and Secure Storage Near Me'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Choosing Storage Near Me',

  cards: [
    {
      id: 1,
      title: 'Convenience and Accessibility',
      description:
        'With storage units near your location, you can quickly access your items anytime, saving your time and effort.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-near-me/convenience-and-accessibility.png',
        alt: 'Convenience and Accessibility'
      }
    },
    {
      id: 2,
      title: 'Affordable Rates',
      description:
        'We offer competitive pricing for storage near you, so you don’t have to pay for unnecessary extra distance or services.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-near-me/affordable-rates.png',
        alt: 'Affordable Rates'
      }
    },
    {
      id: 3,
      title: 'Security and Peace of Mind',
      description:
        'Our local storage facilities are equipped with advanced security features, keeping your belongings safe at all times.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-near-me/security-and-peace-of-mind.png',
        alt: 'Security and Peace of Mind'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Storage Near Me?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Homeowners in Need of Extra Space',
          description:
            "If you're renovating, moving, or just need some extra room, storage units nearby make it easier to store household items temporarily."
        },
        {
          id: 2,
          title: 'Students',
          description:
            'Store your belongings during summer breaks or while moving between dorms and apartments with convenient, nearby storage solutions.'
        },
        {
          id: 3,
          title: 'Small Business Owners',
          description:
            'Keep your inventory, equipment, or documents close by in a secure, affordable storage unit that’s right around the corner.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/storage-near-me/who-should-choose-storage-near-me.jpg',
        alt: 'Who Should Choose Storage Near Me?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Explore Our Additional Storage Solutions',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solutions',
      description:
        'Affordable and convenient storage for businesses needing extra space for inventory or office materials.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Business Storage' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        'Store your items securely during a move, making the transition easier with storage just around the corner.',
      image: {
        src: '/images/v2/pages/common/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Moving Storage' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description:
        'Ship your items locally and internationally with ease, storing them securely in between shipping if needed.',
      image: {
        src: '/images/v2/pages/common/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Box Storage' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description: 'Ideal for homeowners needing temporary storage while moving, renovating, or decluttering.',
      image: {
        src: '/images/v2/pages/common/residential-storage-services.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Residential Storage' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Storage Near Me?',

  image: {
    url: '/images/v2/pages/landing-pages/storage-near-me/why-choose-shipandstorage-for-storage-near-me.jpg',
    alt: 'Why Choose ShipAndStorage for Storage Near Me?'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Access to Local Storage',
      description:
        'Our facilities are strategically located, ensuring you find the perfect storage unit nearby, wherever you are.'
    },
    {
      id: 2,
      title: 'Flexible Storage Options',
      description:
        'Choose from different unit sizes to meet your needs, with flexible rental terms for short or long-term storage.'
    },
    {
      id: 3,
      title: 'Affordable and Transparent Pricing',
      description:
        'Enjoy competitive rates with no hidden fees. Our storage plans are clear and tailored to fit any budget.'
    },
    {
      id: 4,
      title: 'Fast and Reliable Access',
      description: 'Get access to your items whenever you need them with flexible hours and fast customer support.'
    },
    {
      id: 5,
      title: 'Safe and Secure Facilities',
      description:
        'Your items are kept in top-tier security, including 24/7 monitoring, ensuring peace of mind at all times.'
    },
    {
      id: 6,
      title: 'Local Convenience',
      description:
        'Our nearby storage locations mean you never have to travel far to store or retrieve your belongings.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Find Affordable Storage Solutions Near You Today',
  description:
    'Find affordable storage solutions near you. Safe, secure, and affordable options for storing your items today.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-near-me/find-affordable-storage-solutions-near-you-today.png',
    alt: 'Find Affordable Storage Solutions Near You Today'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Book Your Storage Now' }
}

export const ourPartnersSectionContent = {
  description:
    'ShipAndStorage works with leading shipping and logistics companies to provide top-notch storage services.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx ensures reliable and safe storage and shipping solutions, helping to secure your belongings while they are in transit or storage.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL offers secure storage and international shipping, ensuring your items are protected, whether in transit or stored locally.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS provides reliable, secure storage services, with easy access to your stored items and fast, worldwide shipping options.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
